import React, { useContext } from "react";
import { LanguageContext, text } from "../../container/language";
import { buildURLForCategory, buildURLForMenuItem } from "../../utils/buildURL";
import Link from "../../utils/Link";

const Figure = (item) => {
  const { ref, parentCategory, blockMode } = item;
  const { title, subtitle, cover, coverScrollingSlider, slug, excerpt } =
    item.article || item.category || item;
  const { userLanguage } = useContext(LanguageContext);
  let url = "";

  if (blockMode) {
    url = buildURLForMenuItem(item);
  } else {
    url = `${buildURLForCategory(parentCategory)}/${slug}`;
  }

  let coverUrl =
    (coverScrollingSlider && coverScrollingSlider.url) || (cover && cover.url);

  return (
    <li ref={ref} className="trendy-list__item">
      <div className="trendy-list__inner">
        <figure className="trendy-list__preview">
          <div className="trendy-list__preview-wrap">
            <Link to={url}>
              <img
                src={coverUrl}
                style={{ width: "100%" }}
                alt={text(title, userLanguage)}
              />
            </Link>
          </div>
          <figcaption>
            <h2 className="trendy-list__title">
              <Link to={url}>
                <font>
                  <font>{text(title, userLanguage)}</font>
                </font>
              </Link>
            </h2>
            <div className="trendy-list__text">
              <p>
                <font>
                  <font>{text(subtitle, userLanguage)}</font>
                </font>
              </p>
            </div>
            <div className="trendy-list__text">
              <p>{text(excerpt, userLanguage)}</p>
            </div>
          </figcaption>
        </figure>
      </div>
    </li>
  );
};

export default Figure;
